import { src } from '@data'
import { PencilIcon } from '@icons'
import { ADMIN_MODAL_TYPE, useModalStore } from '@modal'
import { Badge, Button, SideDrawer } from '@ui'
import InformationList from '@ui/InformationList'
import { Avatar, Box, Text } from 'grommet'

type Props = {
  onClose: () => void
  id?: string
  defaultData?: any
}

export const RequestDetails = ({ onClose, defaultData, id }: Props) => {
  const { openModal } = useModalStore()

  const details = {
    'Bed type': 'Trauma Stretcher Bed',
    Date: '11/08/2024',
    Feature: 'Telemetry',
    Patient: 'RFOOOGHJK3',
    'Requested by:': (
      <Box direction="row" gap={'4px'}>
        <Avatar size="20px" src={src} />
        <Text
          color={'#000'}
          size="small"
          style={{ maxWidth: '340px', textAlign: 'right', textTransform: 'capitalize' }}
        >
          Dr. Yinka Smith
        </Text>
      </Box>
    ),
    Unit: 'Cardiology Unit'
  }

  const header = (
    <Box gap={'16px'} margin={{ bottom: '40px', vertical: '16px' }}>
      <Box align="center" direction="row" gap={'8px'}>
        <Text size="24px" weight={600}>
          Trauma Stretcher Bed
        </Text>
        <Badge label={'Available'} status="active" />
      </Box>
      <div className="max-w-[157px]">
        <Button
          icon={<PencilIcon />}
          kinds={'secondary'}
          label="Assign bed"
          onClick={() => openModal(ADMIN_MODAL_TYPE.ASSIGN_BED_MODAL, { defaultData: defaultData?.attributes, id })}
          size={'md'}
        />
      </div>
    </Box>
  )
  return (
    <SideDrawer header={header} onClose={onClose} style={{ padding: '0 40px' }} title="Details">
      <Box flex pad={{ horizontal: '24px' }} style={{ overflow: 'hidden', position: 'relative' }}>
        <InformationList data={details} title="Details" />
      </Box>
    </SideDrawer>
  )
}
